import React, { useMemo } from 'react';
import { Icon } from '@appd/uik';
import { HealthStatus } from '.';

type HealthStatusKey = string | number | keyof typeof HealthStatus;

export interface HealthIconCellRendererProps {
  value: HealthStatusKey;
  iconMapping?: Record<HealthStatusKey, Icon.Type>;
}

const DEFAULT_ICON_TYPE = 'Status.Unknown';

const DEFAULT_ICON_MAPPING: Record<HealthStatusKey, Icon.Type> = {
  [HealthStatus.NORMAL]: 'Health.Normal',
  [HealthStatus.UNKNOWN]: DEFAULT_ICON_TYPE,
  [HealthStatus.WARNING]: 'Health.Warning',
  [HealthStatus.CRITICAL]: 'Health.Critical',
};

/**
 * This component renders a horizontally centered icon based on a provided value
 * An optional iconMapping can be provided where a possible value is mapped to its corresponding uik icon type
 */
const HealthIconCellRenderer = React.memo(
  ({ value, iconMapping = DEFAULT_ICON_MAPPING }: HealthIconCellRendererProps): JSX.Element => {
    const iconType = useMemo(() => {
      return iconMapping[value ?? HealthStatus.UNKNOWN] ?? DEFAULT_ICON_TYPE;
    }, [value, iconMapping]);

    return (
      <div className="flex text-center justify-center">
        <Icon type={iconType} size="SMALL" />
      </div>
    );
  },
);

export { HealthIconCellRenderer };
